enum actionTypes {
  FETCH_RATES_BEGIN = 'FETCH_RATES_BEGIN',
  FETCH_RATES_SUCCESS = 'FETCH_RATES_SUCCESS',
  FETCH_RATES_FAILURE = 'FETCH_RATES_FAILURE',

  EXCHANGE_BEGIN = 'EXCHANGE_BEGIN',
  EXCHANGE_SUCCESS = 'EXCHANGE_SUCCESS',
  EXCHANGE_FAILURE = 'EXCHANGE_FAILURE',
}

export { actionTypes };
